import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ajaxSetup } from '@devexpress/analytics-core/core/internal/ajaxSetup';
import { DxReportViewerComponent } from 'devexpress-reporting-angular';
import { UrlConstants } from 'src/app/models/urlConstants';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss']
})
export class ReportingComponent implements OnInit {
  @ViewChild(DxReportViewerComponent, { static: false }) viewer!: DxReportViewerComponent

  @Output() documentReady = new EventEmitter<boolean>()

  @Input() reportUrl!: string
  invokeAction: string = 'DXXRDV'
  @Input() directPrint: boolean = false
  @Input() exportToPdf: boolean = false

  hostUrl: string = UrlConstants.reportsUrl

  constructor(injector: Injector) {
    ajaxSetup.ajaxSettings = {
      headers: { 'Authorization': JSON.parse(sessionStorage.getItem("user")) }
    };
  }

  refreshData(reportUrl: any) {
    this.reportUrl == reportUrl
  }

  ngOnInit(): void {
  }

  fullScreen: boolean = false

  CustomizeMenuActions(event: any) {
    // For demonstration purposes, get the "Search" action and hide it. 
    //var searchAction = event.args.GetById();
    // full screen button number is 15
    //event.args.Actions[15].clickAction = ()=>{this.fullScreen = ! this.fullScreen};

    event.args.Actions[8].clickAction() // click on zoom action many times
    event.args.Actions[8].clickAction() // click on zoom action many times

    //this.fullScreenAction.call()
    // if (searchAction)          
    //     searchAction.visible = false;
  }

  OnServerError($event: any) {
  }

  OnDocumentReady(evt: any) {
    this.documentReady.next(true)
    if (!this.directPrint && !this.exportToPdf)
      this.fullScreen = true
    else if (this.exportToPdf)
      evt.component.bindingSender.ExportTo() //export to pdf
    else
      evt.component.bindingSender.Print()
  }

  OnParameterSubmitted() { }
}